export const startGallerySwipe = function (gallery) {
    gallery.attr('startPosition', gallery.find('.material-gallery-images-container').position().left);
};